import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useUser } from "./userContext";
import { DOMAIN } from "../config";

const FollowContext = createContext();

export const FollowProvider = ({ children }) => {
  const { userData } = useUser();

  const [followMap, setFollowMap] = useState({});
  const [blogerIdMap, setBlogerIdMap] = useState({});

  const setBlogerId = (bloger, id) => {
    setBlogerIdMap(prev => ({ ...prev, [bloger]: id }));
  };

  const setFollowState = (bloger, state) => {
    setFollowMap(prev => ({ ...prev, [bloger]: state }));
  };

  /** 获取 blogerId 并初始化关注状态 */
  const getBlogerId = useCallback(
    async (bloger) => {
      if (!userData) throw new Error("未登录");
      if (blogerIdMap[bloger] !== undefined) return blogerIdMap[bloger];

      const cleanedKeyword = bloger.replace(/\u200B/g, "");
      const response = await fetch(
        `${DOMAIN}ywyblogerbot/getbloger?userid=${userData.id}&bloger=${encodeURIComponent(cleanedKeyword)}`
      );
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();

      if (data.success && data.data?.ID) {
        const id = data.data.ID;
        setBlogerId(bloger, id);

        // ✅ 在这里初始化关注状态，score 不为 null => 已关注
        setFollowState(bloger, data.score != null);

        return id;
      } else {
        setFollowState(bloger, false);
        throw new Error("获取博主信息失败");
      }
    },
    [blogerIdMap, userData]
  );

  /** 切换关注状态 */
  const toggleFollow = async (bloger) => {
    if (!userData) throw new Error("未登录");

    const id = await getBlogerId(bloger);
    const newState = !followMap[bloger];

    const body = { blogerId: id, userId: userData.id };
    if (userData.userid != null) body.telegramid = userData.userid;
    else if (userData.username) body.username = userData.username;

    const url = newState
      ? `${DOMAIN}follow/addFollow`
      : `${DOMAIN}follow/removeFollow`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error("关注请求失败");

    setFollowState(bloger, newState);
    return newState;
  };

  /** ✅ 组件加载时初始化所有关注状态 */
  useEffect(() => {
    if (!userData) return;
    // 这里可以提前初始化几个常用 bloger 的状态，或者在 FollowButton 里调用 getBlogerId
  }, [userData]);

  return (
    <FollowContext.Provider value={{ followMap, setFollowState, toggleFollow, getBlogerId }}>
      {children}
    </FollowContext.Provider>
  );
};

export const useFollow = () => useContext(FollowContext);
